import {IntegrationsView} from "@src/pages/settings/integrations-view";
import {createFileRoute, useMatches, useParams} from "@tanstack/react-router";
import {TProfile} from "@zeg/instant/types";

export const Route = createFileRoute(
  "/_auth/_settings-layout/$workspaceSlug/settings/integrations/"
)({component: RouteComponent});

function RouteComponent() {
  const {workspaceSlug} = useParams({
    from: "/_auth/_settings-layout/$workspaceSlug/settings/integrations/",
  });
  const accumulatedContext = useMatches({
    select: (matches) => matches[matches.length - 1].context,
  });
  const activeProfile = accumulatedContext.auth.profiles.find(
    (profile: TProfile) => {
      const profileWorkspaceSlug = profile.$workspace?.slug;
      return profileWorkspaceSlug === workspaceSlug;
    }
  );
  return <IntegrationsView profileID={activeProfile?.id as string} />;
}
